import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from "reactstrap";
import { useDispatch } from "react-redux";
import { validateAdformS3Config } from "../../../../slices/veloxity/integration/adformS3ValidationSlice";
import { showErrorAlert, showLoadingAlert, showSuccessAlert } from "../../../../components/custom/sweetalertHelper";

const AdFormModal = ({ isOpen, toggle, currentConfig, onSubmit }) => {
    const [formData, setFormData] = useState({});
    const [isVerified, setIsVerified] = useState(false);
    const dispatch = useDispatch();

    const regions = [
        'AF_SOUTH_1', 'AP_EAST_1', 'AP_SOUTH_1', 'AP_NORTHEAST_1', 'AP_NORTHEAST_2',
        'AP_SOUTHEAST_1', 'AP_SOUTHEAST_2', 'CA_CENTRAL_1', 'CN_NORTH_1', 'CN_NORTHWEST_1',
        'EU_CENTRAL_1', 'EU_WEST_1', 'EU_WEST_2', 'EU_WEST_3', 'EU_NORTH_1', 
        'EU_SOUTH_1', 'ME_SOUTH_1', 'SA_EAST_1', 'US_EAST_1', 'US_EAST_2',
        'US_WEST_1', 'US_WEST_2', 'US_GOV_EAST_1', 'GovCloud'
    ];

    useEffect(() => {
        if (currentConfig) {
            setFormData({
                name: currentConfig.name,
                expireDate: currentConfig.expireDate,
                accessKey: currentConfig.metaData.credentials?.accessKey || '',
                secretKey: currentConfig.metaData.credentials?.secretKey || '',
                bucketName: currentConfig.metaData.bucketInfo?.name || '',
                region: currentConfig.metaData.bucketInfo?.region || '',
            });
            setIsVerified(true); 
        } else {
            resetFormData();
        }
    }, [currentConfig]);

    const resetFormData = () => {
        setFormData({
            name: '',
            expireDate: '',
            accessKey: '',
            secretKey: '',
            bucketName: '',
            region: ''
        });
        setIsVerified(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setIsVerified(false); 
    };

    const handleVerify = async () => {
        try {
            showLoadingAlert("Verifying", "Please wait while we verify the AdForm S3 configuration...");
            const adformRequestBody = {
                name: formData.name,
                expireDate: formData.expireDate,
                config: {
                    credentials: {
                        accessKey: formData.accessKey,
                        secretKey: formData.secretKey,
                    },
                    bucketInfo: {
                        name: formData.bucketName,
                        region: formData.region,
                    },
                },
            };
            const result = await dispatch(validateAdformS3Config(adformRequestBody)).unwrap();
            if (result) {
                setIsVerified(true);
                showSuccessAlert("Verification successful", "AdForm S3 verification was successful.");
            }else{
                showErrorAlert("Verification failed", "Please check the input values and try again.");
            }
        } catch (error) {
            showErrorAlert("Verification failed", "Please check the input values and try again.");
        }
    };

    const handleSubmit = () => {
        if (isVerified) {
            onSubmit(formData);
            toggle();  
        } 
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{currentConfig ? 'Edit AdForm S3 Account' : 'Create AdForm S3 Account'}</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="name">Name</Label>
                    <Input type="text" name="name" id="name" value={formData.name} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="expireDate">Expire Date</Label>
                    <Input type="date" name="expireDate" id="expireDate" value={formData.expireDate} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="accessKey">Access Key</Label>
                    <Input type="text" name="accessKey" id="accessKey" value={formData.accessKey} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="secretKey">Secret Key</Label>
                    <Input type="text" name="secretKey" id="secretKey" value={formData.secretKey} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="bucketName">Bucket Name</Label>
                    <Input type="text" name="bucketName" id="bucketName" value={formData.bucketName} onChange={handleInputChange} />
                </FormGroup>
                <FormGroup>
                    <Label for="region">Region</Label>
                    <Input type="select" name="region" id="region"  className="form-control"  value={formData.region} onChange={handleInputChange}>
                        <option value="">Select a region</option>
                        {regions.map((region, index) => (
                            <option key={index} value={region}>{region}</option>
                        ))}
                    </Input>
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleVerify}>Verify</Button>
                <Button color="success" onClick={handleSubmit} disabled={!isVerified}>Submit</Button>
            </ModalFooter>
        </Modal>
    );
};

export default AdFormModal;
